import {useContext} from "react";
import {FiX} from "react-icons/fi";
import {HiMenu} from "react-icons/hi";

import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {NavBarContext} from "@/components/navBar/NavBar.utils.tsx";

export const NavBarToggle = () => {
  const {isMenuOpen, setIsMenuOpen} = useContext(NavBarContext);
  return (
    <IconButton
      icon={isMenuOpen ? FiX : HiMenu}
      variant={"ghost"}
      size={"fitIcon"}
      iconProps={{
        size: "menuIcon",
      }}
      className={"pulse-color-white"}
      onClick={() => {
        setIsMenuOpen(!isMenuOpen);
      }}
    />
  );
};
